import { useMemo } from 'react';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * useApplicationStore
 *
 * Session cache of which JDs the signed-in employee applied to via
 * POST /talent-mobility/apply — drives the "Applied" tag on Career Pathways
 * position cards. The applicant is always the JWT caller, so entries key on
 * the JD alone. The API is idempotent (a repeat apply returns the existing
 * application, no duplicate row), so losing this cache on refresh only
 * costs a round-trip that answers "Already applied to this job."
 */
const useApplicationStore = create(
  devtools(
    (set, get) => ({
      // keyed by jd_sb_unique_id -> { appliedAt }
      applied: {},

      applyForRole: (roleId) =>
        set((state) => ({
          applied: {
            ...state.applied,
            [roleId]: { appliedAt: Date.now() },
          },
        })),

      hasApplied: (roleId) => Boolean(get().applied[roleId]),
    }),
    { name: 'ApplicationStore' }
  )
);

export const useHasApplied = (roleId) => {
  const entry = useApplicationStore((state) => state.applied[roleId]);
  return useMemo(() => Boolean(entry), [entry]);
};

export default useApplicationStore;
